// @ts-nocheck

import { createFileRoute, useNavigate } from '@tanstack/react-router'
import '../App.css'
import '@fontsource/montserrat';
import TaskOverview from '../components/ServiceLocation/TaskOverview';

export const Route = createFileRoute('/tasks')({
  component: RouteComponent,
})

function RouteComponent() {
  
  return <TaskOverview />
}

